import { FaArrowLeft, FaCheck } from 'react-icons/fa';
import activityImg from '../assets/images/activity.png';

const LongQuestionSelectionPage = ({ activity, completedIndexes = [], onSelectQuestion, onBack }) => {
  if (!activity || !activity.baseContent) return null;

  let questions = [];
  try {
    const content = JSON.parse(activity.baseContent);
    questions = content.questions || [];
  } catch (e) {
    console.error('Failed to parse questions:', e);
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-8 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <button
            onClick={onBack}
            className="flex items-center space-x-2 px-4 py-2 bg-white text-gray-700 rounded-lg hover:bg-gray-50 transition-colors shadow-sm font-medium"
          >
            <FaArrowLeft />
            <span>Back to Chapter</span>
          </button>
          <h1 className="text-2xl font-bold text-blue-900">Select a Question</h1>
        </div>

        <div className="grid grid-cols-1 gap-4">
          {questions.map((q, index) => {
            const questionText = q.question?.languageText || q.question?.englishText || `Question ${index + 1}`;
            const isCompleted = completedIndexes.includes(index);
            
            return (
              <button
                key={index}
                onClick={() => onSelectQuestion(q, index)}
                className={`group w-full bg-white p-6 rounded-2xl shadow-md hover:shadow-xl transition-all border flex items-center gap-6 text-left ${
                  isCompleted ? 'border-green-200 bg-green-50/30' : 'border-gray-100'
                }`}
              >
                <div className={`flex-shrink-0 w-12 h-12 rounded-xl flex items-center justify-center font-bold text-lg transition-colors ${
                  isCompleted ? 'bg-green-600 text-white' : 'bg-blue-100 text-blue-600 group-hover:bg-blue-600 group-hover:text-white'
                }`}>
                  {isCompleted ? <FaCheck /> : index + 1}
                </div>
                <div className="flex-grow">
                  <div className={`text-gray-900 font-semibold text-lg line-clamp-2 ${isCompleted ? 'opacity-70' : ''}`}>
                    {questionText}
                  </div>
                  <div className={`text-sm font-medium mt-1 ${isCompleted ? 'text-green-600' : 'text-blue-500'}`}>
                    {isCompleted ? 'Completed - Click to redo' : 'Click to start levels'}
                  </div>
                </div>
              </button>
            );
          })}
        </div>

        {questions.length === 0 && (
          <div className="text-center py-12">
            <p className="text-gray-500 text-lg">No questions available for this activity.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default LongQuestionSelectionPage;
